import './ScheduleBar.css';
import LiveClock from '../../assets/components/LiveClock';
import React from "react";

function ScheduleBar(props) {
    const wakeUp = 5
    const sleep = 21
    const range = (start, end) => Array.from({ length: end - start + 1 }, (_, i) => start + i);
    let hoursRange = range(wakeUp, sleep)

    return (
        <div className="scheduleBar">
            <div className="boxLine"></div>
            <div className="progessBarEdge">
                <div className="innerProgressCircle glowCircle"></div>
            </div>
            <div className="progessBarEdge bottomOfSchedule">
                <div className="innerProgressCircle powerCircle"></div>
            </div>
            <div className="">
                <LiveClock activeBlock={props.activeBlock} setActiveBlock={props.setActiveBlock} />
                {hoursRange.map((hour, nidex) => (
                    <div className=""> 
                        <p className="timeMarkerText"> {hour} </p>
                        <div className="timeMarker"> </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ScheduleBar;